import React from 'react'
import NPSFeedbackReport from '../Components/MHL_Reports/NPSFeedbackReport'

const NPSFeedbackReportPage = () => {
  return (
    <div><NPSFeedbackReport/></div>
  )
}

export default NPSFeedbackReportPage